<template>
  <div v-if="hasRows" class="c-pagination">
    <div class="flex flex-wrap justify-between items-center">
      <div>
        <pagination
          v-bind="$attrs"
          :currentPage="pagination.pageNumber"
          :total-count="pagination.totalCount"
          :per-page="pagination.pageSize"
          :is-compact="isCompact"
          @change="handleChange"
          v-if="pagination.totalCount > pagination.pageSize" />
      </div>
      <div>
        <div class="flex items-center">
          <div class="c-pagination__details">
            {{ firstItem }} - {{ lastItem }} {{ $t('label.of').toLowerCase() }} {{ pagination.totalCount }}
          </div>

          <div class="flex items-center" v-if="hasRows && isCompact === false">
            <label class="c-pagination__rows-label">{{ $t('sentence.rowsPerPage') }}:</label>
            <div class="c-pagination__rows-select-wrapper">
              <base-select
                :options="pageSizeOptions"
                :value="pageSizes.includes(pagination.pageSize) ? pagination.pageSize : pageSizes[0]"
                @input="pagination.pageSize = $event"
                :has-shadow="true"
                :is-searchable="false"
                :is-button="true"
                default-position="top"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from './Pagination'

export default {
  name: 'BasePagination',

  components: { Pagination },

  props: {
    pagination: {
      type: Object,
      required: true,
      default: () => ({
        pageNumber: 1,
        pageSize: 25,
        totalCount: 0
      })
    },
    pageSizes: {
      type: Array,
      default: () => [10, 25, 50, 100]
    },
    isCompact: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /**
     * Map the page sizes to options
     *
     * @returns {Array}
     */
    pageSizeOptions () {
      return this.pageSizes.map(item => ({ value: item, label: `${item}` }))
    },

    /**
     * Does this pagination have any rows?
     *
     * @return {boolean}
     */
    hasRows () {
      return this.pagination.totalCount > 0
    },

    /**
     * Get the first item of the current page.
     *
     * @return {number}
     */
    firstItem () {
      if (!this.hasRows) {
        return 0
      }

      return (this.pagination.pageNumber - 1) * this.pagination.pageSize + 1
    },

    /**
     * Get the last item of the current page.
     *
     * @return {number}
     */
    lastItem () {
      let lastItem = this.pagination.pageNumber * this.pagination.pageSize

      return Math.min(lastItem, this.pagination.totalCount)
    }
  },

  methods: {
    handleChange (event) {
      this.$emit('change', event)
    }
  }
}
</script>
